import { graphql } from 'gql';

export const catalogUEROtherCostTemplatesGql = graphql(`
    query catalogUEROtherCostTemplates(
        $skip: Int
        $take: Int
        $where: CatalogUEROtherCostTemplateDataFilterInput
        $order: [CatalogUEROtherCostTemplateDataSortInput!]
    ) {
        catalogUEROtherCostTemplates(skip: $skip, take: $take, where: $where, order: $order) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                id
                name
                updatedAt
            }
            totalCount
        }
    }
`);

export const catalogUEROtherCostTemplateForUpdateGql = graphql(`
    query catalogUEROtherCostTemplate($id: Int!) {
        catalogUEROtherCostTemplate(id: $id) {
            data {
                file {
                    name
                    size
                    dataUrl
                    count
                }
                id
                name
                updatedAt
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);

export const catalogOtherCostTemplatesNameFilter = graphql(`
    query catalogUEROtherCostTemplateNames(
        $skip: Int
        $take: Int
        $where: CatalogUEROtherCostTemplateDataFilterInput
        $order: [CatalogUEROtherCostTemplateDataSortInput!]
    ) {
        catalogUEROtherCostTemplates(skip: $skip, where: $where, take: $take, order: $order) {
            items {
                name
            }
        }
    }
`);

export const removeCatalogUEROtherCostTemplates = graphql(`
    mutation removeCatalogUEROtherCostTemplates($ids: [Int!]!) {
        removeCatalogUEROtherCostTemplates(ids: $ids) {
            result
            message
        }
    }
`);

export const catalogUpdateOtherCostTemplateGql = graphql(`
    mutation updateCatalogUEROtherCostTemplate($id: Int!, $input: CatalogUEROtherCostTemplateInput!) {
        updateCatalogUEROtherCostTemplate(id: $id, input: $input) {
            data {
                id
                name
                updatedAt
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);

export const catalogCreateOtherCostTemplate = graphql(`
    mutation createCatalogUEROtherCostTemplate($input: CatalogUEROtherCostTemplateInput!) {
        createCatalogUEROtherCostTemplate(input: $input) {
            id
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);

export const catalogIsUniqueNameOtherCostTemplateGql = graphql(`
    query catalogIsUniqueNameOtherCostTemplate($where: CatalogUEROtherCostTemplateDataFilterInput) {
        catalogUEROtherCostTemplates(where: $where) {
            totalCount
        }
    }
`);
